import ExodontiasIcon from '@/components/icons/IndicadoresEsb/Estrategicos/Exodontias.vue'

export default {
  value: 'b3',
  label: 'Exodontias',
  iconType: 'component',
  iconComponent: ExodontiasIcon,
  buscaAtiva: {},
}
